<div class="has-no-connection-wrapper">
    <mat-icon class="no-connection-icon">
        wifi_off
    </mat-icon>
    <h1 appHeading isSmall>Deze tablet kan geen verbinding maken met ACE</h1>
</div>
